<div *ngIf="isPageReady" class="flex flex-col h-full w-full">
  <div class="mb-6">
    <h5>Add Program Type to {{account.name}}</h5>
  </div>
  <div class="flex flex-col w-full h-full gap-3">
    <div class="flex w-full p-2 border-2 border-surface-300 rounded">
      <div class="flex flex-row gap-4">
        <img class="w-auto h-24" src={{img}} />
        <div class="flex flex-col">
          <div class="text-xl">Managed: Fixed Start Date / Fixed End Date</div>
          <div class="text-base">Typically used for Account Users that have already on-boarded through prior
            programs
          </div>
          <div *ngIf="showFF" class="mt-4 grid grid-cols-3 gap-4">
            <prox-field label="Available # of days after join date">
              <p-inputNumber [(ngModel)]="config.data!.availableAfterJoinDateDays"
                name="availableAfterJoinDateDays"></p-inputNumber>
            </prox-field>
            <prox-field label="Start Date">
              <p-datepicker [(ngModel)]="config.data!.startDate" name="startDate"></p-datepicker>
            </prox-field>
            <prox-field label="End Date">
              <p-datepicker [(ngModel)]="config.data!.endDate" name="endDate"></p-datepicker>
            </prox-field>
          </div>
          <div *ngIf="!showFF" class="flex mt-3 mb-2">
            <p-button size="small" label="Select" (onClick)="onSelect('ff')"></p-button>
          </div>
          <div *ngIf="showFF" class="flex mt-3 mb-2 gap-2">
            <p-button size="small" label="Continue" (onClick)="onContinue('ff')"></p-button>
            <p-button size="small" label="Cancel" (onClick)="onCancelSelect()"></p-button>
          </div>
        </div>
      </div>
    </div>
    <div class="flex w-full p-2 border-2 border-surface-300 rounded">
      <div class="flex flex-row gap-4">
        <img class="w-auto h-24" src={{img}} />
        <div class="flex flex-col">
          <div class="text-xl">Managed: Variable Start Date / Variable End Date</div>
          <div class="text-base">Typically used for new Account Users for phase-in on-boarding</div>
          <div *ngIf="showVV" class="mt-4 flex flex-row gap-4">
            <prox-field label="Available # of days after join date">
              <p-inputNumber [(ngModel)]="config.data!.availableAfterJoinDateDays"
                name="availableAfterJoinDateDays"></p-inputNumber>
            </prox-field>
            <prox-field label="Program duration (days)">
              <p-inputNumber [(ngModel)]="config.data!.durationInDays" name="durationInDays"></p-inputNumber>
            </prox-field>
          </div>
          <div *ngIf="!showVV" class="flex mt-3 mb-2">
            <p-button size="small" label="Select" (onClick)="onSelect('vv')"></p-button>
          </div>
          <div *ngIf="showVV" class="flex mt-3 mb-2 gap-2">
            <p-button size="small" label="Continue" (onClick)="onContinue('vv')"></p-button>
            <p-button size="small" label="Cancel" (onClick)="onCancelSelect()"></p-button>
          </div>
        </div>
      </div>
    </div>
    <div class="flex w-full p-2 border-2 border-surface-300 rounded">
      <div class="flex flex-row gap-4">
        <img class="w-auto h-24" src={{img}} />
        <div class="flex flex-col">
          <div class="text-xl">Managed: Variable Start Date / Fixed End Date</div>
          <div class="text-base">Typically used for Account Users who complete a phase-in program and need to
            align to a
            Fixed Start Date program</div>
          <div *ngIf="showVF" class="mt-4 flex flex-row gap-4">
            <prox-field label="Available # of days after join date">
              <p-inputNumber [(ngModel)]="config.data!.availableAfterJoinDateDays"
                name="availableAfterJoinDateDays"></p-inputNumber>
            </prox-field>
            <prox-field label="End Date">
              <p-datepicker appendTo="body" [(ngModel)]="config.data!.endDate" name="endDate"></p-datepicker>
            </prox-field>
          </div>
          <div *ngIf="!showVF" class="flex mt-3 mb-2">
            <p-button size="small" label="Select" (onClick)="onSelect('vf')"></p-button>
          </div>
          <div *ngIf="showVF" class="flex mt-3 mb-2 gap-2">
            <p-button size="small" label="Continue" (onClick)="onContinue('vf')"></p-button>
            <p-button size="small" label="Cancel" (onClick)="onCancelSelect()"></p-button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="flex w-full p-2 border-2 border-surface-300 rounded">
    <div class="flex flex-row gap-4">
      <img class="w-auto h-24" src={{img}} />
      <div class="flex flex-col">
        <div class="text-xl">Inventory</div>
        <div class="text-base">Use this program type to establish and maintain YOUR inventory
          distributed only to {{account.name}} Account Users per program specifications
        </div>
        <!-- <div *ngIf="showInv" class="mt-4 grid grid-cols-3 gap-4">
          <prox-field label="Start Date">
            <p-datepicker [(ngModel)]="config.data!.startDate" name="startDate"></p-datepicker>
          </prox-field>
          <prox-field label="End Date">
            <p-datepicker [(ngModel)]="config.data!.endDate" name="endDate"></p-datepicker>
          </prox-field>
        </div> -->
        <div *ngIf="!showInv" class="flex mt-3 mb-2">
          <p-button size="small" label="Select" (onClick)="onSelect('inv')"></p-button>
        </div>
        <div *ngIf="showInv" class="flex mt-3 mb-2 gap-2">
          <p-button size="small" label="Continue" (onClick)="onContinue('inv')"></p-button>
          <p-button size="small" label="Cancel" (onClick)="onCancelSelect()"></p-button>
        </div>
      </div>
    </div>
  </div>

  <div class="flex mt-6">
    <p-button (onClick)="onCancel()" size="small" icon="pi pi-times" label="Cancel"></p-button>
  </div>
</div>
